import { render } from "./PayReportsQ2.vue?vue&type=template&id=52ba19d8&scoped=true"
import script from "./PayReportsQ2.vue?vue&type=script&lang=js"
export * from "./PayReportsQ2.vue?vue&type=script&lang=js"

import "./PayReportsQ2.vue?vue&type=style&index=0&id=52ba19d8&scoped=true&lang=css"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ba19d8"]])

export default __exports__